"use client";
import { useTranslation } from "react-i18next";
import Link from "next/link";
import React, { useState } from "react";
import { MdOutlineWhatsapp, MdSlowMotionVideo } from "react-icons/md";
import { availableName, uid } from "@/utils/functions";
import { FiSearch } from "react-icons/fi";
import { useEffect } from "react";
import { useDialog } from "@/utils/DialogProvider";
import { TiShoppingCart } from "react-icons/ti";
import { PiPackageBold } from "react-icons/pi";
import { GrDeliver } from "react-icons/gr";



export const HomeBannerCard = ({
  link,
  title,
  subtitle,
  icon,
}: {
  link: string;
  title: string;
  subtitle: string;
  icon: any;
}) => {
  const { t } = useTranslation();
  return (
    <Link
      href={link}
      className={
        "w100  br20 p50 mp15 mpb25 mpt25 c1  mc1 blue-bg grid  home-banner-card   "
      }
    >
      <div className={"w100 grid gap20"}>
        <div className="">
          <div className=" c1 gap10">
            <div className="auto-c1 ">
              <div
                className="  br50 p20 mp10"
                style={{
                  backgroundColor: "#005EFF92",
                }}
              >
                {icon}
              </div>
              <div className="web-only"></div>
            </div>
            <h3 className=" hero-section-big-title white mf15">{t([title])}</h3>
            <p className="white web-only f17 mf15">{t([subtitle])}</p>{" "}
          </div>
        </div>
      </div>
    </Link>
  );
};

export const MobileHomeBannerCard = ({
  link,
  title,
  subtitle,
  icon,
  backgroundColor,
}: {
  link: string;
  title: string;
  subtitle: string;
  backgroundColor: string;
  icon: any;
}) => {
  const { t } = useTranslation();
  return (
    <Link
      href={link}
      className={
        "w100  br20 p50 mp15 mpb25 mpt25 c1 center tcenter  mc1 blue-bg grid   box-shadow br-dark-grey"
      }
      style={{
        backgroundColor: backgroundColor,
        maxWidth: "300px",
        maxHeight: "300px",
      }}
    >
      <div className={"w100 grid gap20"}>
        <div className="">
          <div className="c1 grid gap10">
            <div className="c1 center ">
              <div
                className={` br10 p20 mp10 ${
                  backgroundColor === "#16489f" ? "white-bg" : "blue-bg"
                }`}
              >
                {icon}
              </div>
              <div></div>
              <div></div>
            </div>
            <h3
              className={`hero-section-big-title  mf15 ${
                backgroundColor === "#16489f" ? "white" : "blue"
              }`}
            >
              {t([title])}
            </h3>
            <p className="white f17 web-only mf15">{t([subtitle])}</p>{" "}
          </div>
        </div>
      </div>
    </Link>
  );
};

export const HomeVideosSeciton = () => {
  const {t} = useTranslation()
  const banners = [
    {
      title: {
        en: "Ensure production quality with",
        fr: "Assurez la qualité de production avec",
        ar: "ضمان جودة الإنتاج مع",
      },
      sub_title: {
        en: "Verified Supplier",
        fr: "Fournisseur Vérifié",
        ar: "مورد موثوق",
      },
      description: {
        en: 'Connect with a variety of suppliers with third-party-verified credentials and capabilities. Look for the "Verified" logo to begin sourcing with experienced suppliers your business could rely on.',
        fr: 'Connectez-vous à une variété de fournisseurs dont les compétences et les références ont été vérifiées par des tiers. Recherchez le logo "Vérifié" pour commencer à collaborer avec des fournisseurs expérimentés sur lesquels votre entreprise peut compter.',
        ar: 'تواصل مع مجموعة متنوعة من الموردين الذين تم التحقق من مؤهلاتهم وقدراتهم من قبل أطراف خارجية. ابحث عن شعار "موثوق" لبدء التوريد مع موردين ذوي خبرة يمكن لشركتك الاعتماد عليهم.',
      },
      video: "",
    },
    {
      title: {
        en: "Protect your purchase with",
        fr: "Protégez votre achat avec",
        ar: "احمِ مشترياتك من خلال",
      },
      sub_title: {
        en: "Trade Assurance",
        fr: "Garantie Commerciale",
        ar: "ضمان التجارة",
      },
      description: {
        en: "Source confidently with access to secure payment options, protection against product or shipping issues, and mediation support for any purchase-related concerns when you order and pay on Alibaba.com.",
        fr: "Achetez en toute confiance grâce à des options de paiement sécurisées, une protection contre les problèmes de produits ou d'expédition, et un service de médiation pour tout problème lié à votre commande sur Alibaba.com.",
        ar: "تسوّق بثقة مع خيارات دفع آمنة، وحماية ضد مشاكل المنتجات أو الشحن، ودعم الوساطة لأي مخاوف تتعلق بالشراء عند الطلب والدفع على Alibaba.com.",
      },
      video: "",
    },
    {
      title: {
        en: "Stay guided every step of the way",
        fr: "Soyez accompagné à chaque étape",
        ar: "احصل على التوجيه في كل خطوة",
      },
      sub_title: {
        en: "Responsive Support Team",
        fr: "Équipe d’assistance réactive",
        ar: "فريق دعم سريع الاستجابة",
      },
      description: {
        en: "Our team is available to answer your questions quickly and support you from product sourcing to delivery. Whether it’s logistics, updates, or follow-up, we’re here to ensure a smooth experience.",
        fr: "Notre équipe est disponible pour répondre rapidement à vos questions et vous accompagner de l’approvisionnement à la livraison. Qu’il s’agisse de logistique, de mises à jour ou de suivi, nous sommes là pour garantir une expérience fluide.",
        ar: "فريقنا متاح للرد بسرعة على استفساراتك ودعمك من مرحلة التوريد حتى التسليم. سواء كان الأمر يتعلق باللوجستيات أو التحديثات أو المتابعة، نحن هنا لضمان تجربة سلسة.",
      },
      video: "",
    },
    {
      sub_title: {
        en: "Buy and ship vehicles and goods with confidence",
        fr: "Achetez et expédiez des véhicules et des marchandises en toute confiance",
        ar: "اشترِ وشحن المركبات والبضائع بثقة",
      },
      title: {
        en: "Fast & Global Vehicle & Goods Shipping",
        fr: "Expédition rapide et mondiale de véhicules et marchandises",
        ar: "شحن سريع وعالمي للمركبات والبضائع",
      },
      description: {
        en: "We offer fast, secure purchasing and shipping of vehicles and general goods from China to Algeria, the Middle East, Europe, USA, Canada, and other international destinations. Trust us for reliable, efficient delivery worldwide.",
        fr: "Nous proposons un achat et une expédition rapides et sécurisés de véhicules et de marchandises générales depuis la Chine vers l'Algérie, le Moyen-Orient, l'Europe, les États-Unis, le Canada et d'autres destinations internationales. Faites-nous confiance pour une livraison fiable et efficace partout dans le monde.",
        ar: "نقدم خدمات شراء وشحن سريعة وآمنة للمركبات والبضائع العامة من الصين إلى الجزائر، الشرق الأوسط، أوروبا، الولايات المتحدة، كندا، وغيرها من الوجهات الدولية. ثق بنا لتوصيل موثوق وفعّال في جميع أنحاء العالم.",
      },
      video: "",
    },
  ];
  return (
    <div
      className=" home-videos-banner c1 gap50 white p70"
      style={{
        backgroundImage: "url(/videobanner.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        width: "100%",
      }}
    >
      <h1 className="f40" style={{maxWidth: "600px"}}>
        {t("Trade with confidence from production quality to purchase protection")}{" "}
      </h1>
      <div className="c2 mc1 gap30 vcenter ">
        {banners.map((banner) => (
          <VideoSectionCard banner={banner} key={uid()} />
        ))}
      </div>
    </div>
  );
};


export const VideoSectionCard = ({ banner }: { banner: any }) => {
  const { openDialog } = useDialog();
  const { t, i18n } = useTranslation();
  const currentLocale = i18n.language as "ar" | "fr" | "en";
  return (
    <div className="video-banner-card h100">
      <p className="f17"> {availableName(banner?.sub_title, currentLocale)} </p>
      <h2> {availableName(banner?.title, currentLocale)}</h2>
      <p className="web-only">{availableName(banner?.description, currentLocale)}</p>
      <div>
        <button
          onClick={() => {
            openDialog(t("Watch Video"), <div></div>);
          }}
          className="br50 pt10 pb10 pl30 pr30 br-white  auto-c1  gap10 vcenter"
          style={{
            backgroundColor: "#1D1D1D2E",
            color: "white",
            borderRadius: "50px",
          }}
        >
          <MdSlowMotionVideo size={25} />
          {t("Watch Video")}
        </button>
      </div>
    </div>
  );
};

export const FeaturesSection = () => {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(0);
  const [imageVisible, setImageVisible] = useState(true);

  const {t} = useTranslation()
  const items = [
    {
      title: {
        en: " Get Personalized Support",
        fr: " Bénéficiez d’un accompagnement personnalisé",
        ar: " احصل على دعم مخصص",
      },
      description: {
        en: "Our team is available 24/7 to assist you. From the first contact via WhatsApp, call, or email, we guide you through every step of the process.",
        fr: "Notre équipe est disponible 24h/24 et 7j/7 pour vous assister. Dès le premier contact par WhatsApp, appel ou email, nous vous accompagnons à chaque étape.",
        ar: "فريقنا متاح على مدار الساعة لمساعدتك. من أول تواصل عبر واتساب أو الاتصال أو البريد الإلكتروني، نرشدك في كل خطوة من العملية.",
      },
      icon : <MdOutlineWhatsapp  size={30} />,
      img: ""
    },
    {
      title: {
        en: " Find Products with or without Sourcing",
        fr: " Trouvez vos produits avec ou sans sourcing",
        ar: " اعثر على المنتجات مع أو بدون خدمة الشراء",
      },
      description: {
        en: "We help you identify the best products based on your needs — or we can handle the sourcing entirely through our experienced agents.",
        fr: "Nous vous aidons à identifier les meilleurs produits selon vos besoins — ou nous nous occupons du sourcing entièrement via nos agents expérimentés.",
        ar: "نساعدك في تحديد أفضل المنتجات وفقًا لاحتياجاتك — أو يمكننا تولي عملية الشراء بالكامل من خلال وكلائنا ذوي الخبرة.",
      },
      icon : <FiSearch   size={30}/>,
      img : ""
    },
    {
      title: {
        en: " Purchase with Ease",
        fr: " Achetez en toute simplicité",
        ar: " اشترِ بكل سهولة",
      },
      description: {
        en: "Whether you buy the products yourself or we do it for you, we ensure secure transactions and full transparency throughout the purchasing process.",
        fr: "Que vous achetiez les produits vous-même ou que nous le fassions pour vous, nous garantissons des transactions sécurisées et une transparence totale pendant tout le processus d’achat.",
        ar: "سواء اشتريت المنتجات بنفسك أو قمنا نحن بشرائها نيابةً عنك، نضمن لك معاملات آمنة وشفافية كاملة طوال عملية الشراء.",
      },
      icon : <TiShoppingCart size={30} />,
      img : ""
    },
    {
      title: {
        en: " Fast & Secure Shipping",
        fr: " Expédition rapide et sécurisée",
        ar: " شحن سريع وآمن",
      },
      description: {
        en: "Your goods are received at our warehouse in China, carefully prepared, and shipped to Algeria as well as countries where Amazon operates — including the Middle East, Europe, USA, Canada, and more. We offer reliable delivery worldwide.",
        fr: "Vos marchandises sont réceptionnées dans notre entrepôt en Chine, préparées avec soin et expédiées vers l’Algérie ainsi que vers les pays où Amazon opère — y compris le Moyen-Orient, l’Europe, les États-Unis, le Canada, et plus encore. Nous assurons une livraison fiable dans le monde entier.",
        ar: "تستقبل بضائعك في مستودعنا في الصين، حيث يتم تجهيزها بعناية وشحنها إلى الجزائر وإلى الدول التي تعمل بها أمازون — بما في ذلك الشرق الأوسط، أوروبا، الولايات المتحدة، كندا والمزيد. نوفر توصيلًا موثوقًا به إلى جميع أنحاء العالم.",
      },
      icon : <PiPackageBold size={30} />,
      img : ""
    },
    {
      title: {
        en: " Delivery Within 15 Days Guaranteed",
        fr: " Livraison garantie sous 15 jours",
        ar: " توصيل مضمون في غضون 15 يومًا",
      },
      description: {
        en: "Your order is delivered to Algeria within a maximum of 15 days — fast, safe, and worry-free.",
        fr: "Votre commande est livrée en Algérie en un maximum de 15 jours — rapide, sécurisé et sans souci.",
        ar: "يتم توصيل طلبك إلى الجزائر خلال 15 يومًا كحد أقصى — بسرعة وأمان وراحة بال.",
      },
      icon : <GrDeliver  size={30}/>,
      img : ""
    },
  ];

  // Image fade logic
  useEffect(() => {
    setImageVisible(false);
    const timeout = setTimeout(() => {
      setImageVisible(true);
    }, 100); // Small delay to trigger transition
    return () => clearTimeout(timeout);
  }, [expandedIndex]);

  return (
    <div className="c1 gap30 p50 mp20">
      <h1 className="f40" style={{maxWidth: "600px"}}>
        {t("Streamline ordering from search to fulfillment, all in one place")}
      </h1>
      <div className="c2  mc1 gap30 vcenter">
        <div className="c1 gap30">
          {items.map((item, index) => (
            <>
              <FeatureCard
                key={index}
                index={index}
                title={item.title}
                description={item.description}
                icon={item.icon}
                isExpanded={expandedIndex === index}
                isLastPoint={index === items.length - 1}
                onClick={() =>
                  setExpandedIndex(expandedIndex === index ? null : index)
                }
              />
            </>
          ))}
        </div>

        <div className="p50 w100 relative h-full flex items-center justify-center web-only">
          <img
            src={items[expandedIndex ?? 0].img}
            alt=""
            style={{
              width: "100%",
              maxHeight: "400px",
              transition: "opacity 0.5s ease-in-out",
            }}
            className={`w100 max-w-md transition-opacity duration-500 ease-in-out ${
              imageVisible ? "opacity-100" : "opacity-0"
            }`}
          />
        </div>
      </div>
    </div>
  );
};

type FeatureCardProps = {
  index: number;
  title: { en: string; fr: string; ar: string };
  description: { en: string; fr: string; ar: string };
  icon: React.ReactNode;
  isExpanded: boolean;
  onClick: () => void;
  isLastPoint?: boolean;
};

const FeatureCard = ({
  title,
  description,
  icon,
  isExpanded,
  isLastPoint,
  onClick,
}: FeatureCardProps) => {

  const { t, i18n } = useTranslation();
  const currentLocale = i18n.language as "ar" | "fr" | "en";
  return (
    <div
      className={`auto-c1 gap30 cursor-pointer transition-all duration-300 pointer ${
        isExpanded ? "bg-blue-50 rounded-lg p-2" : ""
      }`}
      onClick={() => onClick()}
    >
      <div className="c1 center gap10">
        <div
          className={`br50 p10 mp10 transition-all duration-300 ${
            isExpanded ? "" : "br-dark-grey"
          }`}
          style={{
            backgroundColor: isExpanded ? "#009DFF2D" : "",
            color: isExpanded ? "#083552FF" : "#9B9B9BFF",
          }}
        >
          {icon}
        </div>
        {!isLastPoint && <Line expanded={isExpanded} />}
      </div>
      <div>
        <h2 className={`transition-all ${isExpanded ? "fw800" : "fw500"}`}>
          {availableName(title, currentLocale)}
        </h2>
        {isExpanded && (
          <p className="f14 dark-grey mt-2 transition-all duration-300">
            {availableName(description, currentLocale)}
          </p>
        )}
      </div>
    </div>
  );
};

const Line = ({ expanded }: { expanded: boolean }) => (
  <div
    style={{
      height: expanded ? "50px" : "30px",
      width: "2px",
      backgroundColor: "#9B9B9BFF",
      borderRadius: "5px",
      transition: "height 0.3s ease",
    }}
  />
);



export const HomeSignUpSeciton = () => {
  const { t } = useTranslation();

  return (
    <div
      className=" home-videos-banner c1 tcenter center gap50 white p100"
      style={{
        backgroundImage:
          "url(/homme-prenant-des-cours-d-apprentissage-electronique.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        width: "100%",
        height: "600px",
      }}
    >
      <div className="c1 gap20 center">
        <h1 className="f40">{t("Ready to get started?")}</h1>
        <p>
         { t("Explore millions of products from trusted suppliers by signing up today!")}
        </p>
        <div>
          <br />{" "}
          <Link href="/signup" className="blue-bg pb15 pt15 pr30 pl30 br10 f20 br50">
            {t("signup")}
          </Link>
        </div>
      </div>
    </div>
  );
};
